import { render } from "./ResultDetail.vue?vue&type=template&id=905baf02&scoped=true"
import script from "./ResultDetail.vue?vue&type=script&lang=js"
export * from "./ResultDetail.vue?vue&type=script&lang=js"

import "./ResultDetail.vue?vue&type=style&index=0&id=905baf02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905baf02"]])

export default __exports__